// @ts-nocheck

import FormControl from '@mui/material/FormControl';
import InputLabel from '@mui/material/InputLabel';
import MenuItem from '@mui/material/MenuItem';
import { useTranslation } from 'react-i18next';

import usePostsCategories from '@/hooks/contentful/usePostsCategories';

import { SelectFilter } from './styles';

function Filter({ setFilter }: { setFilter: (value: Record<string, string>) => void }) {
  const { categories } = usePostsCategories();
  const { t } = useTranslation();

  const categoriesOptions = categories.map((category) => ({
    name: category.fields.categoryName,
    tag: category.fields.tag,
    id: category.sys.id,
  }));

  let filter = {
    orderAsc: 'sys.createdAt',
    orderDesc: '-sys.createdAt',
  };

  categoriesOptions.forEach((category) => (filter = { ...filter, [category.name]: category.id }));

  const handleChangeFilter = (e) => {
    const value = e.value;
    value === 'all'
      ? setFilter({})
      : setFilter((prev) => ({
          ...prev,
          [value.includes('order') ? 'order' : 'category']: filter[value],
        }));
  };

  return (
    <FormControl>
      <InputLabel>{t('BLOG.FILTER_TITLE')}</InputLabel>
      <SelectFilter label="Filtros" onChange={({ target }) => handleChangeFilter(target)}>
        <MenuItem value={'all'}>{t('BLOG.FILTER_ALL')}</MenuItem>
        <MenuItem value={'orderDesc'}>{t('BLOG.FILTER_NEW')}</MenuItem>
        <MenuItem value={'orderAsc'}>{t('BLOG.FILTER_OLD')}</MenuItem>
        {categoriesOptions?.map((category) => (
          <MenuItem value={category.name} key={category.id}>
            {category.name}
          </MenuItem>
        ))}
      </SelectFilter>
    </FormControl>
  );
}

export default Filter;
